export const invoiceNotesMaxLength = 2048;
